module.exports = __webpack_public_path__ + "img/corriente_b_red.33841ad9.svg";